import React from 'react'
import { getHoldText, WorkHoldStatus } from '@App/helpers/work-entities/utils/is-hold-status'
import StatusComponent from '@Components/Status'

interface HoldStatusIndicatorProps {
    holdStatus: WorkHoldStatus
}

const HoldStatusIndicator = (props: HoldStatusIndicatorProps) => {
    const { holdStatus } = props
    const status = getHoldText(holdStatus)
    return status && <StatusComponent status={status} circleFirst />
}

export default HoldStatusIndicator
